export default "__VITE_ASSET__b29e8eda__"